import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { markRaw } from 'vue'
import router from '@/core/config/router.installer'
import { PRIORITIES } from '@/core/constants/installation-priorities.constant'

export const priority = PRIORITIES.PINIA

function createAppStore() {
  const pinia = createPinia()

  pinia.use(({ store }) => {
    store.router = markRaw(router)
  })

  pinia.use(
    createPersistedState({
      key: prefix => `dss_${prefix}`,
      storage: localStorage,
      serializer: {
        serialize: JSON.stringify,
        deserialize: JSON.parse,
      },
    }),
  )

  return pinia
}

const store = createAppStore()

export function install({ app }) {
  app.use(store)
}
